import { SET_REFERRER_SOURCE } from './actionTypes'
import { selectReferrerSource } from 'src/store/selectors/trackingSource'
import { trackHomeActivityMikasa } from 'src/actions/home'

export const trackHomeDigestView = () => (dispatch, getState) => {
  const state = getState()
  const referrerSource = selectReferrerSource(state)

  dispatch(
    trackHomeActivityMikasa({
      eventName: 'view',
      eventProperties: {
        activity_source: referrerSource
      }
    })
  )
  dispatch(setReferrerSource(null))
}

export const setReferrerSource = source => dispatch => {
  dispatch({
    type: SET_REFERRER_SOURCE,
    referrer: source
  })
}
